module.exports = __webpack_public_path__ + "project--video.html";


//////////////////
// WEBPACK FOOTER
// ./app/project--video.pug
// module id = 35
// module chunks = 1